import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import cn from 'classnames';
import { Button, TextField } from 'seagull';
import { Checkmark, Copy } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import styles from './CopyToClipboard.module.scss';
export function CopyToClipboard(props) {
    const { className, buttonClassname, textfieldClassname, value, onClick, onError, onCopy, buttonLabel, testId, size, inlineButton, helperText, error, disabled } = props;
    const resolvedTestId = testId || 'copy-to-clipboard';
    const { copyToClipboard } = useIoContext();
    const { REFERRAL_DASHBOARD_UPGRADE } = useFeatureFlags();
    const inputRef = useRef();
    const [isCopied, setIsCopied] = useState(false);
    const [hasError, setHasError] = useState(false);
    const ButtonWrapper = (param)=>{
        let { children } = param;
        return buttonClassname ? /*#__PURE__*/ _jsx("div", {
            className: buttonClassname,
            children: children
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    };
    const TextfieldWrapper = (param)=>{
        let { children } = param;
        return textfieldClassname ? /*#__PURE__*/ _jsx("div", {
            className: textfieldClassname,
            children: children
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    };
    const copyButton = /*#__PURE__*/ _jsx(Button, {
        bi: {
            name: 'copy_to_clipboard'
        },
        testId: "".concat(resolvedTestId, "-button"),
        prefixIcon: isCopied ? /*#__PURE__*/ _jsx(Checkmark, {}) : /*#__PURE__*/ _jsx(Copy, {
            size: inlineButton ? 16 : 24
        }),
        onClick: ()=>{
            try {
                if (onClick) onClick();
                if (!value) return;
                copyToClipboard(value);
                setIsCopied(true);
                onCopy && onCopy();
                setTimeout(()=>setIsCopied(false), 2000);
            } catch (e) {
                setHasError(true);
                setTimeout(()=>setHasError(false), 2000);
                if (onError) onError();
            }
        },
        loading: !value,
        disabled: isCopied,
        disabledSkin: REFERRAL_DASHBOARD_UPGRADE && isCopied ? 'focused' : undefined,
        className: cn(styles.button, {
            [styles.inlineButton]: inlineButton
        }),
        size: inlineButton ? 'small' : undefined,
        children: isCopied ? 'Copied' : buttonLabel || 'Copy link'
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, {
            [styles.inline]: inlineButton
        }, className),
        "data-testid": resolvedTestId,
        children: [
            /*#__PURE__*/ _jsx(TextfieldWrapper, {
                children: /*#__PURE__*/ _jsx(TextField, {
                    bi: {
                        name: 'copy_to_clipboard'
                    },
                    collapseHelperText: false,
                    size: size,
                    disabled: disabled,
                    inputProps: {
                        readOnly: true
                    },
                    value: value,
                    inputRef: inputRef,
                    onClick: ()=>{
                        var _inputRef_current;
                        return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.select();
                    },
                    onCopy: onCopy,
                    className: styles.input,
                    helperText: hasError ? 'Copy failed. Please try manually or give it another shot later.' : helperText,
                    error: hasError || error,
                    suffix: inlineButton ? copyButton : undefined,
                    testId: "".concat(resolvedTestId, "-input")
                })
            }),
            !inlineButton && /*#__PURE__*/ _jsx(ButtonWrapper, {
                children: copyButton
            })
        ]
    });
}
